export default {
  // 标题
  planLibrary: '计划库',

  // 搜索表单
  taskStatus: '任务状态',
  deviceRouteTask: '设备/航线/任务',
  deviceRouteTaskPlaceholder: '请输入名称',
  planTakeoffTime: '计划起飞时间',
  startTime: '开始时间',
  endTime: '结束时间',
  query: '查询',
  reset: '重置',

  // 视图切换
  table: '表格',
  card: '卡片',
  batchDelete: '批量删除',

  // 任务状态
  allTasks: '全部任务',
  waitingExecution: '等待执行',
  executing: '正在执行',
  paused: '已暂停',
  completed: '已完成',
  cancelled: '已取消',
  executionFailed: '执行失败',

  // 任务信息标签
  taskName: '任务名称',
  type: '类型',
  routeName: '航线名称',
  deviceName: '设备名称',
  actualTime: '实际时间',
  creator: '创建人',
  mediaUpload: '媒体上传',
  executionProgress: '执行进度',

  // 媒体状态
  uploadImmediately: '立即上传',
  mediaUploadEmpty: '无媒体文件',
  mediaUploadToUpload: '待上传',
  mediaUploadUploading: '上传中',
  mediaUploadSuccess: '上传成功',

  // 操作按钮
  delete: '删除',
  suspend: '挂起',
  resume: '恢复',
  viewFiles: '查看文件',
  viewRoute: '查看航线',
  downloadFile: '下载文件',
  breakpointContinueFlight: '断点续飞',
  flightReport: '飞行报告',

  // 确认对话框
  deleteTaskConfirmTitle: '删除任务后将删除相关媒体文件等数据，确定删除吗？',
  deleteTaskConfirmOk: '确定',
  deleteTaskConfirmCancel: '取消',
  suspendTaskConfirmTitle: '您确定要挂起任务吗?',
  suspendTaskConfirmOk: '确定',
  suspendTaskConfirmCancel: '取消',
  resumeTaskConfirmTitle: '您确定要恢复任务吗?',
  resumeTaskConfirmOk: '确定',
  resumeTaskConfirmCancel: '取消',

  // 弹窗
  selectExecuteOrCancelRoute: '请选择执行航线或取消',
  cancelRoute: '取消航线',
  executeRoute: '执行航线',
  executeRouteWarning: '注意: 您有待执行或正在执行的航线任务，如果选择取消航线, 任务将被全部取消； 如果选择执行航线, 请选择一条航线任务执行',
  pleaseSelectRouteTask: '请选择航线任务',

  // 提示消息
  deleteSuccess: '删除成功',
  suspendTaskSuccess: '挂起任务成功',
  resumeTaskSuccess: '已解除挂起任务',
  uploadMediaSuccess: '上传媒体成功',
  breakpointContinueFlightSuccess: '断点续飞成功',
  cancelTaskSuccess: '取消任务成功',

  // 空状态
  noTaskData: '暂无任务数据',

  // 表格列标题
  columnPlanTakeoffTime: '计划起飞时间',
  columnActualTime: '实际时间',
  columnExecutionStatus: '执行状态',
  columnTaskName: '任务名称',
  columnType: '类型',
  columnRouteName: '航线名称',
  columnDeviceName: '设备名称',
  columnCreator: '创建人',
  columnMediaUpload: '媒体上传',
  columnAction: '操作',

  // 创建任务
  createTask: '创建任务',
  taskNamePlaceholder: '请填写任务名称',
  selectRoute: '选择航线',
  selectDevice: '选择设备',
  taskStrategy: '任务策略',
  executionTime: '执行时间',
  startDate: '开始日期',
  endDate: '结束日期',
  startTaskWhenBatteryReaches: '电池电量达到时启动任务',
  startTaskWhenStorageReaches: '当存储级别达到时启动任务 (MB)',
  rthAltitude: '返航高度（相对机场返航高度）(m)：',
  lostActionDuringFlight: '航线飞行中失联：',
  cancel: '取消',
  confirm: '确认',
  updateTime: '更新时间',

  // 验证消息
  pleaseEnterTaskName: '请填写任务名称',
  lengthShouldBe1To20: '长度应为1到20',
  pleaseSelectRoute: '选择航线',
  pleaseSelectDevice: '选择设备',
  pleaseSelectTime: '选择时间',
  pleaseSelectDate: '选择日期',
  rthAltitudeIncorrect: 'RTH 高度不正确',
  pleaseEnterBatteryCapacity: '请输入电池容量',
  pleaseSelectLostAction: '选择失控动作',
  pleaseSelectStartTime: '选择开始时间',
  pleaseSelectEndTime: '选择结束时间',
  endTimeMustBeGreaterThanStartTime: '结束时间必须大于开始时间',
  hasOverlappingTimePeriods: '有重叠时间段.',

  // 任务类型选项
  immediateExecution: '立即执行',
  singleTask: '单次任务',
  repeatedTask: '重复任务',

  // 失控动作选项
  returnToHome: '返航',
  hover: '悬停',
  land: '着陆',
  continueExecution: '继续执行',
}
